/* eslint-disable react-hooks/exhaustive-deps */

import Layout from 'components/layout/Layout';
import ConfigurePriority from './ConfigurePriority';

const ConfigurePriorityView = () => {
  return (
      <Layout showRighSideBar={false}>
        <div className='gne-container'>
          <ConfigurePriority />
        </div>
      </Layout>
  );
};

export default ConfigurePriorityView;
